import { CoreEvent as PlayerCoreEvents } from "@nrk/player-core/types";
const PlayerEvents = {
  ...PlayerCoreEvents,
  EPGChange: "player.EPGChange",
  PlayerError: "player.error",
  PlayNextEpisode: "player.playNextEpisode",
  TrackProgress: "player.trackProgress",
  TrackQoS: "player.trackQoS",
  EcommerceConsumeStart: "player.ecommerceConsumeStart",
  EcommerceConsumeComplete: "player.ecommerceConsumeComplete",
  PlaybackFinished: "player.playbackFinished",
  EnterTheaterMode: "player.enterTheaterMode",
  ExitTheaterMode: "player.exitTheaterMode",
  StreamChange: "player.streamChange",
  ShowChapters: "player.showChapters",
  ShowSettings: "player.showSettings"
};
function isPlayerEvent(event, eventType) {
  return isTypedCustomEventDetail(event, eventType);
}
function isTypedCustomEventDetail(event, eventType) {
  return event.type === eventType;
}
export {
  PlayerEvents,
  isPlayerEvent
};
